module.exports = __webpack_public_path__ + "vue-app/img/arrow-left.0296d469.svg";